<template>
  <div>
    <div class='menu-item' >
      <ul  @mouseleave="onUnHoverTopWrap($event)">
        <li class="dropdown float-left " v-for='(item, index)  in menuList' :key="index" >
          <div class="dropbtn unactive" @mouseover='onHoverTop($event)' @mouseleave="onUnHoverTop($event)">{{item.caption}}</div>
          <div class="dropdown-content">
            <div class='sub-menu float-left'  v-for='(sub, index1)  in item.subMenu' :key="index1" @click='onMenuClick($event,sub)'
              @mouseover='onHover($event)' @mouseleave="onUnHoverSub($event)" :disabled='dis'>
              {{sub.caption}}
            </div>
          </div>
        </li>
      </ul>

    </div>
    <div class='sub-menu'>
      <dx-check-box class='new-tab'
        :value.sync="isNewTab"
        :width="100"
        text="새탭열기"
      />
    </div>
  </div>
</template>

<script>
import { DxCheckBox } from 'devextreme-vue/check-box'
import AppLib from '../AppLib'

export default {
  name: 'TopMenuHComponent',
  props: {
    menuList: Array
  },
  components: {
    DxCheckBox
  },
  data: function () {
    return {
      selectedTopMenu: null,
      dis: true,
      isNewTab: false,
      userInfo: null
    }
  },
  created () {
  },
  mounted () {
    this.userInfo = this.$store.getters.getUserInfo
    let vm = this
    let width = 0
    this.$Q('.dropdown').each(function (index) {
      // console.log(vm.$Q(this).width())
      width += vm.$Q(this).width()
    })
    this.$Q('.menu-item ul').css('width', (width + 1) + 'px')

    // submenu class명 할당

    this.$Q('.dropdown').each(function (index, item) {
      let className = 'top-menu-' + index
      vm.$Q(item).addClass(className)
    })
    for (let i = 0; i < this.menuList.length; i++) {
      let topClass = '.top-menu-' + i + ' .sub-menu'
      this.$Q(topClass).each(function (index, item) {
        let className = 'sub-menu-' + i + index
        vm.$Q(item).addClass(className)
        vm.menuList[i].subMenu[index].className = className
      })
    }
    this.$store.commit('saveTopmenu', this.menuList)

    // select subMenu
    setTimeout(() => {
      this.selectSubMenu()
    }, 500)

    // permission
    this.setPermission()
  },
  updated () {
  },
  beforeDestroy: function () {

  },
  methods: {
    setPermission () {
      let userGroup = this.$store.getters.getUserInfo.permission
      // console.log(userGroup)
      // topMenu search
      for (let i = 0; i < this.menuList.length; i++) {
        let className = '.top-menu-' + i
        // onsole.log(this.menuList[i].permission)
        if ((this.menuList[i].permission & userGroup) === 0) {
          this.$Q(className).hide()
        }
        for (let j = 0; j < this.menuList[i].subMenu.length; j++) {
          if ((this.menuList[i].subMenu[j].permission & userGroup) === 0) {
            let subClass = '.' + this.menuList[i].subMenu[j].className
            this.$Q(subClass).hide()
          }
        }
      }
      this.$Q()
    },
    selectSubMenu () {
      let current = this.$route.path
      for (let i = 0; i < this.menuList.length; i++) {
        for (let j = 0; j < this.menuList[i].subMenu.length; j++) {
          if (this.menuList[i].subMenu[j].url !== null && this.menuList[i].subMenu[j].url.indexOf(current) >= 0) {
            let className = '.' + this.menuList[i].subMenu[j].className
            this.$Q('.dropbtn').removeClass('active')
            this.$Q('.dropbtn').addClass('unactive')
            this.selectedTopMenu = this.$Q(className).parent().parent().find('.dropbtn')
            // console.log(className)
            this.selectedTopMenu.addClass('active')
            this.selectedTopMenu.removeClass('unactive')
            this.$Q('.dropdown-content').hide()
            this.$Q('.active').parent().find('.dropdown-content').show()

            // submenu active color
            this.$Q('.dropdown-content div').removeClass('active-sub-menu')
            if (current !== '/main') { this.$Q(className).addClass('active-sub-menu') }
            this.initHoverTop(className)
            return
          }
        }
      }
    },
    initHoverTop (subClass) {
      let w = this.$Q(subClass).parent().width() / 2
      let topW = this.$Q(subClass).parent().parent().width() / 2

      let left = this.$Q(subClass).parent().parent().position().left - w + topW
      if (left < 10) {
        left = 10
      }
      this.$Q(subClass).parent().css('left', left + 'px')
    },
    onUnHoverTopWrap (e) {
      if (this.selectedTopMenu !== null) {
        // console.log('onUnHoverTopWrap')
        this.$Q(this.selectedTopMenu).parent().find('.dropdown-content').show()
      }
    },
    onTopClick (e, item) {
      // 사용하지 않음 subMenu없는 TopMenu현재 지원안됨
      let current = this.$route.path
      if (current.indexOf(item.url) >= 0) {
        return
      }
      if (item.subMenu.length === 0) {
        // console.log(item.url)
        this.$router.push(item.url)
      }
    },
    onMenuClick (e, item) {
      this.$Q('.dropbtn').removeClass('active')
      this.$Q('.dropbtn').addClass('unactive')
      this.selectedTopMenu = this.$Q(e.target).parent().parent().find('.dropbtn')
      this.selectedTopMenu.addClass('active')
      this.selectedTopMenu.removeClass('unactive')
      this.$Q('.active').parent().find('.dropdown-content').show()

      // submenu active color
      this.$Q('.dropdown-content div').removeClass('active-sub-menu')
      this.$Q(e.target).addClass('active-sub-menu')

      let current = this.$route.path
      if (current.indexOf(item.url) >= 0) {
        let path = current.substring(current.indexOf(item.url), current.length)
        if (path === item.url) return
      }
      if (this.isNewTab) {
        window.open(item.url, '_blank')
        this.selectSubMenu()
        this.isNewTab = false
      } else {
        if (item.url.indexOf('myPage') > 0) {
          this.$router.push(`${item.url}?beforeUrl=${current}`)
          // this.$router.push(`/myPage?beforeUrl=${this.$route.path}`)
        } else {
          // this.savePageAccessHis(item)
          // console.log('url=' + item.url)
          this.$router.push(item.url)
        }
      }
    },
    savePageAccessHis (item) {
      let param = [
        {
          accessDate: AppLib.getNow(),
          menuName: item.caption,
          userId: this.userInfo.userId,
          userName: this.userInfo.userName,
          menuUrl: item.url
        }
      ]
      this.$_sp.runInsertSqlProc('PAGE_ACCESS_HIS', null, param)
        .then((data) => {
        })
        .catch(error => {
          console.log(error)
        })
    },
    onHover (event) {
      this.$Q('.dropdown-content').hide()
      this.$Q('.dropdown:hover .dropdown-content').show()
    },
    onHoverTop () {
      if (this.selectedTopMenu !== null) {
        this.selectedTopMenu.parent().find('.dropdown-content').hide()
      }
      let w = this.$Q('.dropdown:hover .dropdown-content').width() / 2
      let topW = this.$Q('.dropdown:hover').width() / 2

      let left = this.$Q('.dropdown:hover').position().left - w + topW
      if (left < 10) {
        left = 10
      }
      this.$Q('.dropdown:hover .dropdown-content').css('left', left + 'px')
      this.$Q('.dropdown-content').hide()
      this.$Q('.dropdown:hover .dropdown-content').show()
    },
    onUnHoverTop (e) {
      if (this.selectedTopMenu === this.$Q(e.target)) {
        this.selectedTopMenu.parent().children('.dropdown-content').show()
      }

      this.$Q('.dropdown-content').hide()
      // this.$Q('.dropdown:hover .dropdown-content').show()
    },
    onUnHoverSub (e) {
      this.$Q('.dropdown-content').hide()
      if (this.selectedTopMenu !== null) {
        this.selectedTopMenu.parent().children('.dropdown-content').show()
      }
    }

  }
}
/*
options ={
  height: 42,
  topMenuHoverColor,
  topMenuFontColor:white,
  subMenuHoverColor,
  subMenuFontColor:white,
}
*/

</script>

<style lang="scss">
.menu-item{
  margin-left:150px;
  ul {
    list-style-type: none;
    margin: 0;
    padding: 0;
    overflow: hidden;
    li{
      height:34px;
    }
  }
  .dropbtn {
    display: inline-block;
    color: white;
    text-align: center;
    height:36x;
    line-height:36px;
    padding:0 20px;
    text-decoration: none;
    cursor: default;
  }

  .dropbtn div:hover, .dropdown:hover .dropbtn {
    background-color: #17769b;
  }
  /*
  .dropbtn.dropdown {
    display: inline-block;
  }*/

  .dropdown-content {
    display: none;
    position: absolute;
    top:34px;
    min-width: 160px;
    height:44px;
    line-height:44px;
    z-index: 1;
  }

  .dropdown-content div {
    color: white;
    height:44px;
    line-height:44px;
    padding: 0 10px;
    text-decoration: none;
    display: block;
    text-align: left;
    cursor: pointer;
  }

  .dropdown-content div:hover {background-color: #38a7d2;}

/*
  .dropdown:hover .dropdown-content {
    display: block;
  }*/
  .active{
    background-color: #066086;
  }
  .active-sub-menu{
    color:#52fa24!important;
  }

}
.sub-menu{
  position: relative;
  height:44px;
  background-color: #066086;
  .new-tab {
    position:absolute;
    right:0;
    top:10px;
    color:rgb(208, 207, 207);
    .dx-checkbox-icon {
      background-color: rgb(208, 207, 207);
    }
  }
}

</style>
